import { createRouter, createWebHashHistory } from 'vue-router';

const files = import.meta.globEager('@/view/*/router.js');

let route = [];

for (const f in files) {
  const o = files[f].default;
  o.path = o.path || `/${f.split('/')[2]}`;
  route = [].concat(route, o);
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    ...route,
    // { path: "/:pathMatch(.*)*", redirect: { path: "/intention/home" } },
  ],
});



window.$router = router;

export default router;
